import { gql } from '@apollo/client'
import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription, 
    DataMapper,
    StatusChipComponentCreator,
    NullClickStrategy,
    SimpleTableDisplayStrategy,
    DateTimeComponentCreator,
    DateDisplayCreator,
    PeriodSubProcessStateChipComponentCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { companyPeriodActions } from './InvoiceInvoicePeriodsTableCreator'
import {RawTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/RawTableQueryBuilder";

const tableQuery = gql`
    query CompanyPeriodSubProcesses(
        $companyPeriodId:String,
        $action:String,
        $orderField:String,
        $first:Int,
        $last:Int,
        $after:String,
        $before:String,
    ) {
        companyPeriodSubProcesses(
            companyPeriodId:$companyPeriodId,
            action:$action,
            orderField:$orderField,
            first:$first,
            last:$last,
            after:$after,
            before:$before,
        ) {
            edges {
                node {
                    id
                    taskName
                    state
                    createdAt
                    action
                }
            }
            count
            pageInfo {
                hasNextPage
                startCursor
                endCursor
            }
        }
    }
`

let editMutator

let newMutator

let deleteMutator

let unitQuery

const InvoicePeriodSubProcessUnitQueryTableCreatorCreatorQueries = {tableQueryBuilder: new RawTableQueryBuilder(tableQuery), editMutator, newMutator, deleteMutator, unitQuery}


class InvoicePeriodSubProcessUnitQueryTableCreatorCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InvoicePeriodSubProcessUnitQueryTableCreatorCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(
            this.constructor.getId(), 
            tableName, 
            InvoicePeriodSubProcessUnitQueryTableCreatorCreatorQueries, 
            new NullClickStrategy(), 
            new SimpleTableDisplayStrategy()
        );
        tableCreator.setDefaultRowHeight(25);

        tableCreator.setDescriptions([
            new TableFieldDescription(
                'taskName',
                new DataMapper("taskName"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Process'}
            ),
            new TableFieldDescription(
                'state',
                new DataMapper("state"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'State', componentCreator: new StatusChipComponentCreator()}
            ),
            new TableFieldDescription(
                'action',
                new DataMapper('action'),
                new f.FilterDescription(new f.NullCreator()),
                {
                    label: ('Action'), componentCreator: new PeriodSubProcessStateChipComponentCreator(companyPeriodActions),
                }
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper("createdAt"),
                new f.FilterDescription(new f.DateFilter('createdAt')),
                {label: 'Executed At', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateDisplayCreator()}
            ),
        ])

        return tableCreator
    }
}


tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InvoicePeriodSubProcessUnitQueryTableCreatorCreator)

export default InvoicePeriodSubProcessUnitQueryTableCreatorCreator
